import { useEffect, useState } from "react";
import { Ruler } from "lucide-react";

// Medición editable inline (valor numérico + unidad de solo lectura).
export default function MeasureCell({ value, unit, onSave, testId }) {
  const [v, setV] = useState(value ?? "");
  useEffect(() => { setV(value ?? ""); }, [value]);

  const commit = () => {
    const raw = String(v).trim().replace(",", ".");
    if (raw === "") { setV(value ?? ""); return; } // vacío => sin cambios
    const num = Number(raw);
    if (Number.isNaN(num)) { setV(value ?? ""); return; }
    if (num !== (value ?? null)) onSave(num);
  };

  return (
    <div
      className="flex items-center shrink-0 rounded-lg border border-border bg-secondary/60 pl-1.5 focus-within:ring-1 focus-within:ring-primary focus-within:border-primary"
      title="Medición del área (editable)"
    >
      <Ruler className="h-3.5 w-3.5 text-muted-foreground" />
      <input
        value={v}
        onChange={(e) => setV(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); e.currentTarget.blur(); } }}
        inputMode="decimal"
        placeholder="—"
        aria-label="Medición del área"
        data-testid={testId}
        className="h-7 w-14 bg-transparent px-1 text-xs font-mono text-center focus:outline-none placeholder:text-muted-foreground/70"
      />
      <span className="pr-2 text-[10px] font-medium text-muted-foreground">{unit || "ud"}</span>
    </div>
  );
}
